export { type DidDocumentSelfGetRequest } from './DidDocumentSelfGetRequest';
